import clickOutside from './click-outside'

export default [clickOutside]
